'use strict';

/**
 * Model for matching
 *
 * @category   Model
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoModel = require('base/Colido.Model');

var MatchModel = ColidoModel.extend({
    defaults: {
        dismissed: false,
    },

    /**
     * Checks if the model has selected a column
     * @returns {boolean} True, if it has a column selected
     */
    hasColumnSelected: function() {
        return !!this.get('fieldname') && !this.get('dismissed');
    },

    validate: function(attrs, options) {
        if (!this.get('fieldname') && !this.get('dismissed')) {
            return 'no fieldname selected and not dismissed';
        }
    },
});

module.exports = MatchModel;